import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

console.log('[App] React mounting...');
createRoot(document.getElementById("root")!).render(<App />);
